var init = function () {
  // find the badge container
  let badgeContainer = document.getElementById("product-badge");
  if (badgeContainer == undefined) return;

  var requestOptions = {
    method: "GET",
    redirect: "manual",
  };

  const domain = window.location.hostname.split(".").slice(1).join('.')
  const url = new URL('https://content-eu-1.content-cms.com/api/f43b0181-6ee9-4539-b3e9-f7f37a95f962/delivery/v1/search')
  const searchParams = new URLSearchParams();
  searchParams.append('fl', 'generatedFiles')
  searchParams.append('wt', 'json')
  searchParams.append('fq', 'classification:(content)')
  searchParams.append('fq', 'type:("badge widget")')
  searchParams.append('sort', 'sortableNumber1 asc')
  searchParams.append('q', '{!join from=categoryLeaves to=categoryLeaves v=$q1}')
  searchParams.append('q1', `((number1:${badgeContainer.dataset.productId}  AND -(categories:(Reece website domain))) OR (number1:${badgeContainer.dataset.productId} AND (categories:(Reece website domain) AND categoryLeaves:(${domain}))))`)
  url.search = searchParams.toString()
  // run an acoustic content hub solr search
  // find Badge Widgets which have the same category as our Bade Product
  fetch(
    url,
    requestOptions
  )
    .then((response) => response.json())
    .then((data) => {
      // console.log(data);
      if (data.numFound && data.numFound > 0) {
        for (let badge of data.documents) {
          // return the ssr html from acoustic content hub
          fetch(
            `https://content-eu-1.content-cms.com/f43b0181-6ee9-4539-b3e9-f7f37a95f962${badge.generatedFiles[0]}`,
            requestOptions
          )
            .then((response) => response.text())
            .then((data) => {
              // insert every badge, PDP can show more than 1
              let badgeEl = document.createElement("div");
              badgeEl.innerHTML = data;
              badgeContainer.appendChild(badgeEl);
            })
            .catch();
        }
      }
    })
    .catch();

  try {
    let customOrder = document.getElementById("product-detail-page").getAttribute('data-custom-order');
    if (customOrder) {
      let badgeEl = document.createElement("div");
      badgeEl.classList.add("badge-container");

      badgeEl.innerHTML =
        `<rg-badge priority="default" style="--badge-background-color: #94BAF6;--badge-border-color: #94BAF6;--badge-hover-background-color: #94BAF6;--badge-focus-background-color: #94BAF6;" class="hydrated">
                <span><rg-icon icon="zmdi zmdi-time-countdown" margin="right" ratio="1" theme="" class="hydrated"></rg-icon>Made to Order</span>
            </rg-badge>`;
      badgeContainer.appendChild(badgeEl);
    }
  } catch (err) {
    throw new Error(err);
  }

};

export default { init };
